import { render, staticRenderFns } from "./integration.vue?vue&type=template&id=35e8f544&scoped=true"
import script from "./integration.vue?vue&type=script&lang=js"
export * from "./integration.vue?vue&type=script&lang=js"
import style0 from "./integration.vue?vue&type=style&index=0&id=35e8f544&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e8f544",
  null
  
)

export default component.exports